import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Navigate, Outlet } from 'react-router-dom';
import { useState } from 'react';
import AppNavbar from './dashboard/AppNavbar';
import Header from './dashboard/Header';
import SideMenu from './dashboard/SideMenu';
import NavbarBreadcrumbs from './dashboard/NavbarBreadcrumbs';
import { useSiteSession } from '../context/SiteSessionContext';

export default function DashboardLayout() {
  const { session } = useSiteSession();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  if (!session) {
    return <Navigate to="/connexion" replace />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <SideMenu collapsed={sidebarCollapsed} onToggleCollapsed={() => setSidebarCollapsed((value) => !value)} />
      <AppNavbar />
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          minHeight: '100vh',
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          borderLeft: '1px solid',
          borderColor: 'divider',
        })}
      >
        <Stack
          spacing={2}
          sx={{
            mx: { xs: 1.25, sm: 2, md: 3.75 },
            pb: { xs: 3, md: 5 },
            mt: { xs: 7.5, md: 1.5 },
            minWidth: 0,
          }}
        >
          <Header />
          <Box sx={{ display: { xs: 'none', md: 'block' }, width: '100%' }}>
            <NavbarBreadcrumbs />
          </Box>
          <Box
            sx={{
              width: '100%',
              minWidth: 0,
              '& .MuiTypography-h4': {
                fontSize: { xs: '1.55rem', sm: '2rem', md: '2.125rem' },
                lineHeight: 1.12,
              },
              '& .MuiCardContent-root': {
                p: { xs: 1.5, sm: 2 },
              },
              '& .MuiDataGrid-root': {
                fontSize: { xs: 12, sm: 13 },
              },
              '& .MuiTableContainer-root': {
                overflowX: 'auto',
              },
              '& .MuiTable-root': {
                minWidth: { xs: 760, md: 'unset' },
              },
            }}
          >
            <Outlet />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
